import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
  Form,
  reduxForm,
} from 'redux-form';

import ContactInput from '../../components/ContactInput/ContactInput';
import ContactMessageField from '../../components/ContactMessageField/ContactMessageField';

import {
  email,
  phone,
  required,
} from '@utils/validators';

import './ContactForm.scss';

const ContactForm = ({
  handleSubmit,
}) => (
  <Form
    className="contact-form"
    onSubmit={handleSubmit}
  >
    <div className="contact-form__row contact-form__row--two-children">
      <Field
        name="firstName"
        label="First name"
        required
        component={ContactInput}
        validate={[required]}
      />
      <Field
        name="lastName"
        label="Last name"
        required
        component={ContactInput}
        validate={[required]}
      />
    </div>
    <div className="contact-form__row">
      <Field
        name="company"
        label="Company"
        component={ContactInput}
      />
    </div>
    <div className="contact-form__row contact-form__row--two-children">
      <Field
        name="email"
        label="Email Address"
        required
        component={ContactInput}
        validate={[required, email]}
      />
      <Field
        name="phone"
        label="Phone"
        component={ContactInput}
        validate={[phone]}
      />
    </div>
    <div className="contact-form__row">
      <Field
        name="message"
        required
        component={ContactMessageField}
        validate={[required]}
      />
    </div>
    <div className="contact-form__row">
      <button
        type="submit"
        className="contact-form__submit-button"
      >
        Submit
      </button>
    </div>
  </Form>
);

ContactForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'contact',
})(ContactForm);



// WEBPACK FOOTER //
// ./src/routes/Contact/forms/ContactForm/ContactForm.js